module.exports = __webpack_public_path__ + "static/media/sp12.4af76e39.JPG";